import React, { Component } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import ChatContacts from "./contacts";
import Convo from "./convo";
import ConvoNavBar from "./convoNavBar";
import ConvoFooter from "./convoFooter";
import InfiniteScroll from "react-infinite-scroll-component";
// import { MultiSelect } from "react-multi-select-component";
import MultiSelect from "react-multi-select-component";
import axios from "axios";
import * as Cookies from "es-cookie";
import convoBg from "../../../../images/messages/convoBg.jpg";

const DEFAULT_API_BASE = process.env.REACT_APP_API_BASE || "";

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${Cookies.get("token") || ""}` },
});

class WhatsAppLayout extends Component {
  constructor(props) {
    super(props);
    // Allow embedding screens to point this UI at a specific backend (e.g. the
    // rizee REST endpoints) without changing the default messagesCenter usage.
    this.API_BASE = props.apiBase != null ? props.apiBase : DEFAULT_API_BASE;
    this.lastMsgRef = React.createRef();
    this.state = {
      waMessageContacts: [],
      hasMore: false,
      page: 1,
      loading: false,

      selectedUser: null,
      waMessageChats: [],
      hasMoreChats: false,
      chatPage: 1,
      loadingChats: false,
      status1: "idle",

      waContactUserFilterArr: {
        branchDepartments: [],
        tags: [],
        qrCodes: [],
        organisations: [],
      },

      selectedBrachDeptValue: [],
      selectedTagValue: [],
      selectQrCodeValue: [],
      selectOrganizationValue: [],
      searchUser: "",
      activeButton: 0,

      typeMessage: "",
      isReplyMessage: null,

      addTagModal: false,

      templates: [],
      campaignInputParams: [],
      getTags: [],
      openLeadChatConvo: false,

      status: "idle",
      isMobile: window.matchMedia("(max-width:900px)").matches,
    };
  }

  componentDidMount() {
    this.mediaQuery = window.matchMedia("(max-width:900px)");
    this.handleMQ = (e) => this.setState({ isMobile: e.matches });
    this.mediaQuery.addEventListener("change", this.handleMQ);
    window.addEventListener("keydown", this.handleGlobalKeyDown);

    this.fetchContactFilters();
    this.fetchTemplates();
    this.fetchCampaignInputParams();
    this.fetchChatContacts(1);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedBrachDeptValue,
      selectedTagValue,
      selectQrCodeValue,
      selectOrganizationValue,
      searchUser,
      selectedUser,
      waMessageChats,
      chatPage,
    } = this.state;

    const filtersChanged =
      prevState.selectedBrachDeptValue !== selectedBrachDeptValue ||
      prevState.selectedTagValue !== selectedTagValue ||
      prevState.selectQrCodeValue !== selectQrCodeValue ||
      prevState.selectOrganizationValue !== selectOrganizationValue ||
      prevState.searchUser !== searchUser;

    if (filtersChanged) this.fetchChatContacts(1);

    if (prevState.selectedUser !== selectedUser && selectedUser !== null) {
      this.fetchChats(selectedUser, 1);
    }

    if (chatPage === 1 && prevState.waMessageChats !== waMessageChats) {
      this.scrollToLastMsg();
    }
  }

  componentWillUnmount() {
    if (this.mediaQuery)
      this.mediaQuery.removeEventListener("change", this.handleMQ);
    window.removeEventListener("keydown", this.handleGlobalKeyDown);
  }

  handleGlobalKeyDown = (event) => {
    if (event.key === "Escape") {
      this.setState({ selectedUser: null, waMessageChats: [] });
    }
  };

  prepareFilterValues(selectedValues, allOptions = []) {
    if (
      !selectedValues ||
      selectedValues.length === 0 ||
      selectedValues.length === allOptions.length
    )
      return [];
    return selectedValues.map((v) => v.value);
  }

  scrollToLastMsg() {
    // Scroll only inside the chat container — `block: "nearest"` avoids scrolling
    // the page (which would push the WhatsApp/SMS tabs out of view).
    if (this.lastMsgRef?.current) {
      this.lastMsgRef.current.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
  }

  // Mark a contact's incoming messages as read: clear the unread badge locally
  // (also drops the "Unread" tab count) and tell the backend.
  async markSeen(id) {
    if (!id || Number(id) < 0) return;
    this.setState((prev) => ({
      waMessageContacts: prev.waMessageContacts.map((c) =>
        c.wa_contact_id === id ? { ...c, unread: 0 } : c,
      ),
    }));
    try {
      await axios.post(`${this.API_BASE}/wa/seen`, { wa_contact_id: id }, authHeaders());
    } catch (e) {
      /* ignore */
    }
  }

  async fetchContactFilters() {
    try {
      const res = await axios.get(
        `${this.API_BASE}/wa/contact-filters`,
        authHeaders(),
      );
      if (res.data) {
        const filters = res.data.data || res.data;
        this.setState({
          waContactUserFilterArr: filters,
          selectedBrachDeptValue: filters.branchDepartments || [],
          selectedTagValue: filters.tags || [],
          selectQrCodeValue: filters.qrCodes || [],
          selectOrganizationValue: filters.organisations || [],
        });
      }
    } catch {
      /* filters load silently */
    }
  }

  async fetchChatContacts(page = 1) {
    const {
      activeButton,
      selectedBrachDeptValue,
      selectedTagValue,
      selectQrCodeValue,
      selectOrganizationValue,
      searchUser,
      waContactUserFilterArr,
    } = this.state;

    this.setState({ loading: true });
    try {
      const res = await axios.post(
        `${this.API_BASE}/wa/contacts`,
        {
          page,
          limit: activeButton === 0 ? 50 : 100,
          filterType: activeButton,
          branch_department_ids: this.prepareFilterValues(
            selectedBrachDeptValue,
            waContactUserFilterArr.branchDepartments,
          ),
          tag_ids: this.prepareFilterValues(
            selectedTagValue,
            waContactUserFilterArr.tags,
          ),
          qr_code_ids: this.prepareFilterValues(
            selectQrCodeValue,
            waContactUserFilterArr.qrCodes,
          ),
          organisation_ids: this.prepareFilterValues(
            selectOrganizationValue,
            waContactUserFilterArr.organisations,
          ),
          search: searchUser?.trim() || "",
        },
        authHeaders(),
      );
      const data = res.data?.data || [];
      const hasMore = res.data?.hasMore || false;
      this.setState((prev) => ({
        waMessageContacts:
          page === 1 ? data : [...prev.waMessageContacts, ...data],
        hasMore,
        page,
        loading: false,
      }));
    } catch {
      this.setState({ loading: false });
    }
  }

  async fetchChats(contactId, page = 1) {
    this.setState({ loadingChats: true, status1: "loading" });
    try {
      const res = await axios.post(
        `${this.API_BASE}/wa/chats`,
        { wa_contact_id: contactId, limit: 20, page },
        authHeaders(),
      );
      const data = res.data?.data || [];
      const hasMoreChats = res.data?.hasMore || false;
      this.setState((prev) => ({
        waMessageChats: page === 1 ? data : [...data, ...prev.waMessageChats],
        hasMoreChats,
        chatPage: page,
        loadingChats: false,
        status1: "idle",
      }));
    } catch {
      this.setState({ loadingChats: false, status1: "idle" });
    }
  }

  async fetchTemplates() {
    try {
      const res = await axios.get(`${this.API_BASE}/wa/templates`, authHeaders());
      this.setState({ templates: res.data?.data || res.data || [] });
    } catch {
      /* silent */
    }
  }

  async fetchCampaignInputParams() {
    try {
      const res = await axios.get(
        `${this.API_BASE}/campaign/input-params`,
        authHeaders(),
      );
      this.setState({ campaignInputParams: res.data?.data || res.data || [] });
    } catch {
      /* silent */
    }
  }

  async fetchTags() {
    try {
      const res = await axios.get(`${this.API_BASE}/tags`, authHeaders());
      this.setState({ getTags: res.data?.data || res.data || [] });
    } catch {
      /* silent */
    }
  }

  // Optional write-permission gate. Embedding screens (e.g. the Communication
  // Management WhatsApp tab) pass a `canSend` function; it returns false and pops their
  // Access Denied modal when the role lacks is_edit. When the prop is absent (the default
  // messagesCenter usage) sends are never blocked.
  isSendAllowed() {
    return typeof this.props.canSend !== "function" || this.props.canSend();
  }

  async sendMessage(formData) {
    if (!this.isSendAllowed()) return;
    try {
      const res = await axios.post(
        `${this.API_BASE}/wa/send-message`,
        formData,
        authHeaders(),
      );
      if (res.data) await this.fetchChats(this.state.selectedUser, 1);
    } catch {
      console.error("Failed to send message");
    }
  }

  async sendTemplate(payload) {
    if (!this.isSendAllowed()) return { success: false, message: "Access denied" };
    try {
      const res = await axios.post(
        `${this.API_BASE}/wa/send-template`,
        payload,
        authHeaders(),
      );
      if (res.data?.success || res.data?.status === "success") {
        await this.fetchChats(this.state.selectedUser, 1);
        return { success: true, message: res.data.message || "Template sent" };
      }
      return { success: false, message: res.data?.message || "Failed to send" };
    } catch {
      return { success: false, message: "Server error" };
    }
  }

  async updateContactTags(payload) {
    await axios.post(`${this.API_BASE}/wa/update-contact`, payload, authHeaders());
    const updatedContacts = this.state.waMessageContacts.map((c) =>
      c.wa_contact_id === payload.wa_contact_id
        ? { ...c, tag_id: payload.tag_id }
        : c,
    );
    this.setState({ waMessageContacts: updatedContacts });
    await this.fetchTags();
  }

  async uploadFile(filesPayload) {
    try {
      const res = await axios.post(
        `${this.API_BASE}/upload`,
        { file: filesPayload, category: "userImages" },
        authHeaders(),
      );
      return res.data?.data || null;
    } catch {
      console.error("File upload failed");
      return null;
    }
  }

  handleTabSwitch(value) {
    this.setState(
      { activeButton: value, selectedUser: null, waMessageChats: [] },
      () => {
        this.fetchChatContacts(1);
      },
    );
  }

  handleMultiSelectChange(name, selectedValues) {
    this.setState({ [name]: selectedValues, selectedUser: null });
  }

  render() {
    const {
      status,
      loading,
      isMobile,
      selectedUser,
      waMessageContacts,
      waMessageChats,
      hasMore,
      hasMoreChats,
      loadingChats,
      chatPage,
      typeMessage,
      isReplyMessage,
      addTagModal,
      templates,
      campaignInputParams,
      getTags,
      openLeadChatConvo,
      waContactUserFilterArr,
      selectedBrachDeptValue,
      selectedTagValue,
      selectQrCodeValue,
      selectOrganizationValue,
      searchUser,
      activeButton,
      status1,
    } = this.state;

    return (
      <div style={{ backgroundColor: "#f0f2f5", padding: "8px 4px" }}>
        <Card
          style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.12)" }}
        >
          {/* Filters */}
          {!this.props.hideFilters && status !== "loading" && (
            <div
              style={{
                padding: 12,
                backgroundColor: "#f5f5f5",
                borderRadius: 8,
              }}
            >
              <Row>
                <Form.Group as={Col} lg={3} md={6} sm={12} className="mb-2">
                  <Form.Label
                    className="text-uppercase font-weight-bold"
                    style={{ fontSize: 12 }}
                  >
                    Branch / Dept
                  </Form.Label>
                  <MultiSelect
                    options={waContactUserFilterArr?.branchDepartments || []}
                    value={selectedBrachDeptValue || []}
                    onChange={(val) =>
                      this.handleMultiSelectChange(
                        "selectedBrachDeptValue",
                        val,
                      )
                    }
                    labelledBy="Branch / Dept"
                    overrideStrings={{
                      allItemsAreSelected: "All branches selected",
                      selectSomeItems: "Select Branch / Dept",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} lg={3} md={6} sm={12} className="mb-2">
                  <Form.Label
                    className="text-uppercase font-weight-bold"
                    style={{ fontSize: 12 }}
                  >
                    Tag
                  </Form.Label>
                  <MultiSelect
                    options={waContactUserFilterArr?.tags || []}
                    value={selectedTagValue || []}
                    onChange={(val) =>
                      this.handleMultiSelectChange("selectedTagValue", val)
                    }
                    labelledBy="Tag"
                    overrideStrings={{
                      allItemsAreSelected: "All tags selected",
                      selectSomeItems: "Select Tag",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} lg={3} md={6} sm={12} className="mb-2">
                  <Form.Label
                    className="text-uppercase font-weight-bold"
                    style={{ fontSize: 12 }}
                  >
                    QR Code
                  </Form.Label>
                  <MultiSelect
                    options={waContactUserFilterArr?.qrCodes || []}
                    value={selectQrCodeValue || []}
                    onChange={(val) =>
                      this.handleMultiSelectChange("selectQrCodeValue", val)
                    }
                    labelledBy="QR Code"
                    overrideStrings={{
                      allItemsAreSelected: "All QR codes selected",
                      selectSomeItems: "Select QR Code",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} lg={3} md={6} sm={12} className="mb-2">
                  <Form.Label
                    className="text-uppercase font-weight-bold"
                    style={{ fontSize: 12 }}
                  >
                    Organization
                  </Form.Label>
                  <MultiSelect
                    options={waContactUserFilterArr?.organisations || []}
                    value={selectOrganizationValue || []}
                    onChange={(val) =>
                      this.handleMultiSelectChange(
                        "selectOrganizationValue",
                        val,
                      )
                    }
                    labelledBy="Organization"
                    overrideStrings={{
                      allItemsAreSelected: "All organizations selected",
                      selectSomeItems: "Select Organization",
                    }}
                  />
                </Form.Group>
              </Row>
            </div>
          )}

          <Card.Body>
            {status === "loading" ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: 300 }}
              >
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <Row noGutters>
                {/* Contacts panel */}
                <Col xs={12} md={3}>
                  {(!isMobile || (isMobile && selectedUser === null)) && (
                    <div
                      style={{
                        borderRight: "1px solid #e9edef",
                        overflow: "hidden",
                        height: "calc(100vh - 290px)",
                        minHeight: 380,
                        display: "flex",
                        flexDirection: "column",
                        background: "#fff",
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #e9edef",
                          backgroundColor: "#fff",
                          padding: "10px 12px",
                          zIndex: 10,
                        }}
                      >
                        {/* Search (above the All / Un-read tabs) */}
                        <div className="input-group input-group-sm mb-2">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#f0f2f5", border: "none", borderRadius: "18px 0 0 18px" }}
                            >
                              <i className="fas fa-search text-muted" />
                            </span>
                          </div>
                          <Form.Control
                            size="sm"
                            placeholder="Search name or number"
                            value={searchUser}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (!value.startsWith(" "))
                                this.setState({ searchUser: value });
                            }}
                            style={{ backgroundColor: "#f0f2f5", border: "none", borderRadius: "0 18px 18px 0" }}
                          />
                        </div>

                        {/* All / Un-read tabs with unread count */}
                        <div className="d-flex" style={{ gap: 8 }}>
                          {[
                            { value: 0, label: "All", count: "" },
                            {
                              value: 1,
                              label: "Unread",
                              count:
                                waMessageContacts.filter(
                                  (item) => Number(item.unread) > 0,
                                ).length || "",
                            },
                          ].map((item) => (
                            <Button
                              key={item.value}
                              variant={
                                activeButton === item.value
                                  ? "success"
                                  : "outline-secondary"
                              }
                              size="sm"
                              style={{ borderRadius: 16, fontWeight: 500, fontSize: 12, padding: "2px 14px" }}
                              onClick={() => this.handleTabSwitch(item.value)}
                            >
                              {item.label}
                              {item.count !== "" && (
                                <span
                                  style={{
                                    marginLeft: 6,
                                    background: activeButton === item.value ? "#fff" : "#25D366",
                                    color: activeButton === item.value ? "#25D366" : "#fff",
                                    borderRadius: 10,
                                    padding: "0 6px",
                                    fontSize: 11,
                                    fontWeight: 700,
                                  }}
                                >
                                  {item.count}
                                </span>
                              )}
                            </Button>
                          ))}
                        </div>
                      </div>

                      <div
                        id="scrollableDiv"
                        style={{
                          width: "100%",
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <InfiniteScroll
                          dataLength={waMessageContacts?.length || 0}
                          next={() =>
                            this.fetchChatContacts(this.state.page + 1)
                          }
                          hasMore={hasMore}
                          loader={
                            loading && (
                              <p className="text-center">Loading more...</p>
                            )
                          }
                          endMessage={
                            <p
                              className="text-center text-muted"
                              style={{ fontSize: 12 }}
                            >
                              No more contacts
                            </p>
                          }
                          scrollableTarget="scrollableDiv"
                        >
                          {loading ? null : (
                            <ChatContacts
                              waMessageContacts={waMessageContacts}
                              selectedUser={selectedUser}
                              onSelectUser={(id) => {
                                this.setState({
                                  selectedUser: id,
                                  waMessageChats: [],
                                  typeMessage: "",
                                  isReplyMessage: null,
                                });
                                this.markSeen(id);
                              }}
                            />
                          )}
                        </InfiniteScroll>
                      </div>
                    </div>
                  )}
                </Col>

                {/* Chat panel */}
                <Col xs={12} md={9}>
                  {(!isMobile || (isMobile && selectedUser !== null)) && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "calc(100vh - 290px)",
                        minHeight: 380,
                        overflow: "hidden",
                        width: "100%",
                      }}
                    >
                      {/* Empty / intro state — doodle background with a centered
                          placeholder card. */}
                      {selectedUser === null && !isMobile && (
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundImage: `linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url(${convoBg})`,
                            backgroundSize: "auto, 300px",
                            backgroundRepeat: "repeat, repeat",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 10,
                              background: "rgba(255,255,255,0.85)",
                              borderRadius: 16,
                              padding: "28px 36px",
                              boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                            }}
                          >
                            <div
                              style={{
                                width: 64,
                                height: 64,
                                borderRadius: "50%",
                                background: "#25D366",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 6px 16px rgba(37,211,102,0.35)",
                              }}
                            >
                              <i className="fab fa-whatsapp" style={{ color: "#fff", fontSize: 32 }} />
                            </div>
                            <div style={{ fontSize: 17, fontWeight: 600, color: "#111b21" }}>
                              Your Messages
                            </div>
                            <div style={{ fontSize: 13, color: "#667781", textAlign: "center", maxWidth: 240 }}>
                              Select a contact from the left to start a conversation.
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Navbar — only when a conversation is open (avoids an
                          empty bordered strip / "middle line" otherwise). */}
                      {selectedUser !== null && (
                        <div
                          style={{
                            flexShrink: 0,
                            borderBottom: "1px solid #ddd",
                            backgroundColor: "#fff",
                            zIndex: 10,
                          }}
                        >
                          <ConvoNavBar
                            selectedUser={selectedUser}
                            waMessageContacts={waMessageContacts}
                            addTagModal={addTagModal}
                            openLeadChatConvo={openLeadChatConvo}
                            getTags={getTags}
                            onBack={() =>
                              this.setState({
                                selectedUser: null,
                                waMessageChats: [],
                              })
                            }
                            onCloseTagModal={() =>
                              this.setState({ addTagModal: false })
                            }
                            onCloseLeadChat={() =>
                              this.setState({
                                openLeadChatConvo: false,
                                waMessageChats: [],
                              })
                            }
                            onUpdateTags={(payload) =>
                              this.updateContactTags(payload)
                            }
                          />
                        </div>
                      )}

                      {/* Chat body — only when a conversation is open */}
                      {selectedUser !== null && (
                        <div
                          id="scrollableChatDiv"
                          style={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            backgroundImage: `linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url(${convoBg})`,
                            backgroundSize: "auto, 300px",
                            backgroundRepeat: "repeat, repeat",
                            padding: 16,
                            display: "flex",
                            flexDirection: "column-reverse",
                            gap: 8,
                          }}
                        >
                          <InfiniteScroll
                            dataLength={
                              Object.values(
                                waMessageChats?.[0]?.messages || {},
                              ).flat().length
                            }
                            next={() =>
                              !loadingChats &&
                              hasMoreChats &&
                              this.fetchChats(selectedUser, chatPage + 1)
                            }
                            hasMore={hasMoreChats}
                            inverse={true}
                            scrollableTarget="scrollableChatDiv"
                            style={{
                              display: "flex",
                              flexDirection: "column-reverse",
                            }}
                            loader={
                              <p className="text-center">
                                Loading more messages...
                              </p>
                            }
                          >
                            {chatPage === 1 && loadingChats ? (
                              <div className="d-flex justify-content-center py-2">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              </div>
                            ) : (
                              <Convo
                                lastMsgRef={this.lastMsgRef}
                                waMessageChats={waMessageChats}
                                status1={status1}
                                onReplyMessage={(msg) =>
                                  this.setState({ isReplyMessage: msg })
                                }
                              />
                            )}
                          </InfiniteScroll>
                        </div>
                      )}

                      {/* Footer — only when a conversation is open */}
                      {selectedUser !== null && (
                        <div
                          style={{
                            flexShrink: 0,
                            borderTop: "1px solid #e9edef",
                            backgroundColor: "#fff",
                            zIndex: 10,
                          }}
                        >
                          <ConvoFooter
                            canSend={this.props.canSend}
                            typeMessage={typeMessage}
                            isReplyMessage={isReplyMessage}
                            selectedUser={selectedUser}
                            waMessageChats={waMessageChats}
                            templates={templates}
                            campaignInputParams={campaignInputParams}
                            scrollToLastMsg={() => this.scrollToLastMsg()}
                            onMessageChange={(e) =>
                              this.setState({ typeMessage: e.target.value })
                            }
                            onReplyChange={(msg) =>
                              this.setState({ isReplyMessage: msg })
                            }
                            onSelectUser={(id) =>
                              this.setState({ selectedUser: id })
                            }
                            onMessageSubmit={(formData) =>
                              this.sendMessage(formData)
                            }
                            onSendTemplate={(payload) =>
                              this.sendTemplate(payload)
                            }
                            onUploadFile={(filesPayload) =>
                              this.uploadFile(filesPayload)
                            }
                          />
                        </div>
                      )}
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default WhatsAppLayout;
